import { useTranslation } from "react-i18next";
import { StatusBadge } from "@/components/shared/StatusBadge";

function storageSettingStatusLabelKey(state: string) {
  switch (state) {
    case "ready":
    case "pending":
    case "blocked":
    case "unknown":
    case "disabled":
      return state;
    default:
      return null;
  }
}

export function StorageSettingStatusBadge({
  state,
}: {
  state: string;
}) {
  const { t } = useTranslation("storages");
  const labelKey = storageSettingStatusLabelKey(state);
  const badgeState = state === "unknown" ? "degraded" : state;

  return (
    <StatusBadge
      state={badgeState}
      label={labelKey ? t(`settingStatusValues.${labelKey}`) : undefined}
    />
  );
}
